import React, { ReactNode } from 'react';
import { styled } from '@mui/material/styles';
import {
  Box,
  Container
} from '@mui/material';
import AliphiaHeader from './AliphiaHeader';

interface InvoiceDashboardLayoutProps {
  children?: ReactNode;
}

// Main content area that uses full width
const Main = styled('main')(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  paddingTop: theme.spacing(11),
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  width: '100%',
  marginLeft: 0,
  direction: 'ltr',
  backgroundColor: '#f8f9fa',
}));

// Special Dashboard Layout without sidebar for invoice pages
const InvoiceDashboardLayout: React.FC<InvoiceDashboardLayoutProps> = ({ children }) => {
  return (
    <Box sx={{ display: 'flex', direction: 'ltr', minHeight: '100vh' }}>
      <AliphiaHeader />
      
      <Main>
        <Container maxWidth={false} sx={{ px: { xs: 2, sm: 3, md: 4 }, maxWidth: '1600px', mx: 'auto' }}>
          <Box sx={{ position: 'relative' }}>
            {children}
          </Box>
        </Container>
      </Main>
    </Box>
  );
};

export default InvoiceDashboardLayout;